<template>
    <div>
        <v-dialog v-model="dialog" max-width="1000" max-height="90vh">
            <files-viewer v-model="valueLocal" :filter="filter" @close="dialog = false" :form="form" :readonly="readonly" :disabled="disabled" />
        </v-dialog>
        <autocomplete-multiple :key="autocompleteKey" v-model="valueLocal" :label="label" item-text="label" @input="$emit('change')" item-value="id" url="/api/Files/Autocomplete" :disabled="disabled" :readonly="readonly" />
        <v-btn class="pr-2 pl-2" min-width="0" @click="saveAndOpenDialog()" :disabled="disabled">
            <v-icon class="mr-1">mdi-folder-multiple-image</v-icon>
            Save and View Files
        </v-btn>
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'form',
            'itemId',
            'parentColumnName',
            'label',
            'readonly',
            'disabled',
            'canOpen'
        ],

        components: {
            filesViewer: () => import('../components/FilesViewer'),
            autocompleteMultiple: () => import('../components/AutocompleteMultiple')
        },

        data() {
            return {
                dialog: false,
                autocompleteKey: 0,
                viewFilesClicked: false
            };
        },

        methods: {
            saveAndOpenDialog() {
                this.$emit('save');
                this.viewFilesClicked = true
            }
        },

        computed: {
            valueLocal: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.autocompleteKey += 1;
                    this.$emit('input', value);
                }
            },
            filter() {
                var filter = {};
                filter[this.parentColumnName] = this.itemId;
                return filter;
            }
        },

        watch: {
            canOpen() {
                if (this.canOpen && this.viewFilesClicked) {
                    this.viewFilesClicked = false;
                    this.dialog = true;
                }
            }
        }
    };
</script>
